export const _en = {
    name: {
        label: "Name"
    },
    firstName: {
        label: "First name"
    },
    uid: {
        label: "User uid"
    },
    comment: {
        label: "Comments"
    },
    refTraineePositionId: {
        label: "Function"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    firstName: {
        label: "Prénom"
    },
    uid: {
        label: "Matricule"
    },
    comment: {
        label: "Commentaires"
    },
    refTraineePositionId: {
        label: "Type"
    }
};